
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import LessonsHero from './components/LessonsHero';
import BookingSection from './components/BookingSection';
import TeacherInfo from './components/TeacherInfo';
import LessonBenefits from './components/LessonBenefits';

const LessonsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <LessonsHero />
        <TeacherInfo />
        <LessonBenefits />
        <BookingSection />
      </main>
      <Footer />
    </div>
  );
};

export default LessonsPage;
